import React from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import HomeListing from '../Pages/HomeListing.js'
import Category from '../Pages/Category/index.js'

const Home = () => {
  return (
    <>
      <Header/>
      
      <Category/>
      <HomeListing/>
     
      
      <Footer/>
    </>
  )
}

export default Home
